import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import ToastAx            from 'app/actions/toast';
import EllipsisMenu       from 'app/components/common/ellipsis-menu';
import Icon               from 'app/components/common/icon';
import Link               from 'app/components/common/link';
import Meta               from 'app/components/common/meta';
import Modal              from 'app/components/common/modal';
import StandardInput      from 'app/components/common/standard-input';
import ModalManageStages  from 'app/components/company-admin/grant-system/modal-manage-stages';
import ModalTaskEdit      from 'app/components/company-admin/grant-system/modal-task-edit';
import WorkflowCols       from 'app/components/company-admin/grant-system/workflow-cols';
import CadminLayout       from 'app/components/company-admin/layout/';
import PageLoading        from 'app/components/layout/page-loading';
import GrantSysDuck       from 'app/ducks/company-admin/grant-system';
import helpers            from 'app/helpers/grant-system';
import history            from 'app/history';
import paths              from 'app/paths';
import prompts            from 'app/prompts';
import CadminSlx          from 'app/selectors/company-admin/';

const {TaskTypes, StageTypes} = helpers;



const stageTypeLabels = {
  [StageTypes.USER_DEFINED]: 'Custom Stage',
  [StageTypes.SYSTEM_DECIDE]: 'System - Final Decision',
  [StageTypes.SYSTEM_APPROVED]: 'System - Approved',
  [StageTypes.SYSTEM_DECLINED]: 'System - Declined',
}

class CadminPageGrantWorkflowEdit extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      showManageStages: false,
      showSettings: false,
      taskModal: null,
      title: '',
      savePending: false,
    };

    this.onCloseTaskModal = this.onCloseTaskModal.bind(this);
    this.onClickStages = this.onClickStages.bind(this);
    this.onClickSettings = this.onClickSettings.bind(this);
    this.onCloseSettings = this.onCloseSettings.bind(this);
    this.onClickSaveSettings = this.onClickSaveSettings.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onCloseStages = this.onCloseStages.bind(this);
    this.renderAbove = this.renderAbove.bind(this);
    this.renderBelow = this.renderBelow.bind(this);
  }

  get isTemplate() {
    return !this.props.workflow?.grantProgramId;
  }

  get savePending() {
    return !!(this.props.updatePending || this.props.deletePending);
  }

  onClickStages() {
    this.setState({showManageStages: true});
  }
  onCloseStages() {
    this.setState({showManageStages: false});
  }

  onClickSettings() {
    this.setState({showSettings: true, title: this.props.workflow.title});
  }
  onCloseSettings() {
    this.setState({showSettings: false});
  }
  onClickSaveSettings() {
    this.props.update(this.props.workflow.id, {title: this.state.title}).then(() => {
      this.onCloseSettings();
    });
  }
  async onClickDelete() {
    const msg = 'Are you sure you want to delete this workflow template?';
    const didConfirm = await prompts.confirm({msg, danger: 'Delete Workflow Template'});
    if (didConfirm) {
      this.props.delete(this.props.workflow.id).then(() => {
        this.props.toastSuccess('Workflow template deleted.');
        const path = paths.cadminGrantSysSettings(this.props.company.slug, 'workflows');
        history.push(path);
      });
    }
  }
  onChangeTitle(event, title) {
    this.setState({title});
  }

  onClickNewTask(stage) {
    this.setState({taskModal: [stage]});
  }
  onClickEditTask(stage, task) {
    this.setState({taskModal: [stage, task]});
  }
  onCloseTaskModal() {
    this.setState({taskModal: null});
  }

  renderSettings() {
    const {workflow} = this.props;
    const {savePending} = this;
    const {showSettings, title} = this.state;
    if (!showSettings || !workflow) return null;
    const canSave = !!(!savePending && ((title || '').trim()));

    return (
      <Modal onClose={this.onCloseSettings} className="bform">
        <h1 className="bform-h1">Workflow Settings</h1>

        <label className="bform-h3">Title</label>
        <StandardInput name="title" label="Title" value={title} onChange={this.onChangeTitle} />

        <div className="bform-actions">
          {this.isTemplate && (
            <button className="btn danger secondary" onClick={this.onClickDelete} disabled={savePending}>Delete</button>
          )}
          <div className="bform-actions-right">
            <button className="btn blue" onClick={this.onClickSaveSettings} disabled={!canSave}>{savePending ? 'Saving...' : 'Save'}</button>
          </div>
        </div>
      </Modal>
    );
  }

  renderAbove(stage, workflow) {
    const isCustom = stage.type === StageTypes.USER_DEFINED;
    const label = stageTypeLabels[stage.type];
    return <div className="gwfe-stage-abv" style={{color: stage.color}}>{label}</div>;
  }

  renderBelow(stage, workflow) {
    const {tasks} = stage;
    return (
      <div className="gwfe-stage-blw">
        <div className="gwfe-tasks">
          {tasks.map((task) => {
            const typeObj = helpers.taskTypeObj(task);
            const {IconComp} = typeObj;
            return (
              <div key={task.id} className="gwfe-task">
                <div className="gwfe-task-top">
                  <div className="gtask-type-chip"><IconComp />{helpers.taskMetaLabel(task)}</div>
                  <EllipsisMenu>
                    <button onClick={this.onClickEditTask.bind(this, stage, task)}><Icon.Pencil /> Edit</button>
                  </EllipsisMenu>
                </div>
                <div className="gwfe-task-title">{task.title}</div>
              </div>
            );
          })}
        </div>
        <button className="btn small secondary ghost slate icon _mt-24" onClick={this.onClickNewTask.bind(this, stage)}><Icon.Add sw1_5 /> Add Task</button>
      </div>
    );
  }

  renderMain() {
    const {workflow} = this.props;
    if (!workflow) return 'loading...';

    return (
      <WorkflowCols workflow={workflow} renderAbove={this.renderAbove} renderBelow={this.renderBelow} className="gwfe-cols" />
    );
  }

  render() {
    const {company, workflow} = this.props;
    const {taskModal} = this.state;
    if (!company) return <PageLoading />;
    const title = workflow ? `Edit Workflow: ${workflow.title}` : 'Edit Workflow';

    return (
      <CadminLayout company={company} activeItem="grant-settings" className="gwfe" dnd>
        <Meta title={`${title} | Millie`} />

        <div className="ca-main-head">
          {this.isTemplate
            ? <Link href={paths.cadminGrantSysSettings(company.slug, 'workflows')} className="ca-main-head-back"><Icon.Caret direction="left" /> Workflow Templates</Link>
            : <Link href={paths.cadminGrantProgram(company.slug, workflow.grantProgramId)} className="ca-main-head-back"><Icon.Caret direction="left" /> Program</Link>
          }
          <h1 className="ca-main-head-h1">{title}</h1>
          <div className="ca-main-head-actions">
            <button className="btn secondary slate icon" onClick={this.onClickSettings} disabled={!workflow}><Icon.Cog1 /> Settings</button>
            <button className="btn blue" onClick={this.onClickStages} disabled={!workflow}>Manage Stages</button>
          </div>
        </div>

        <div className="_mt-36">
          {this.renderMain()}
        </div>

        {!!(workflow && this.state.showManageStages) && (
          <ModalManageStages workflow={workflow} onClose={this.onCloseStages} />
        )}

        {/* <pre>{JSON.stringify({taskModal},null,4)}</pre> */}

        {!!(workflow && taskModal) && (
          <ModalTaskEdit workflow={workflow} stage={taskModal[0]} task={taskModal[1] || null} onClose={this.onCloseTaskModal} />
        )}

        {this.renderSettings()}

      </CadminLayout>
    );
  }

}

CadminPageGrantWorkflowEdit.propTypes = {
  company: PropTypes.object,
  workflow: PropTypes.object,
};

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  workflow: GrantSysDuck.Slx.pathWorkflow(state),
  updatePending: GrantSysDuck.Slx.wfUpdatePending(state),
  deletePending: GrantSysDuck.Slx.wfDeletePending(state),
});
const dispatchToProps = (dispatch) => ({
  update: (wfId, attrs) => dispatch(GrantSysDuck.Ax.workflowsUpdate(null, wfId, attrs)),
  delete: (wfId) => dispatch(GrantSysDuck.Ax.workflowsDelete(null, wfId)),
  toastSuccess: (msg) => dispatch(ToastAx.success(msg)),
});

export default connect(stateToProps, dispatchToProps)(CadminPageGrantWorkflowEdit);
